<template>
  <div class="imp">
    <section class="imp__hero">
      <div class="wt-container">
        <span class="wt-eyebrow">Rechtliches</span>
        <h1 class="imp__h">Impressum</h1>
        <p class="imp__lead">
          Waizmann.089 ist ein Service der <strong>WaizmannTabelle GmbH</strong> —
          unabhängiger Versicherungsmakler, Familienbetrieb aus München, seit 1995.
        </p>
      </div>
    </section>

    <section class="imp__body">
      <div class="wt-container">
        <div class="imp__grid">
          <article class="imp-block">
            <span class="imp-block__tag">Anbieter</span>
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              WaizmannTabelle GmbH<br />
              Ludwig-Ganghofer-Straße 6<br />
              82031 Grünwald<br />
              Deutschland
            </p>
            <h3>Geschäftsführung &amp; Gesellschafter</h3>
            <p>Florian Meier</p>
          </article>

          <article class="imp-block">
            <span class="imp-block__tag">Kontakt</span>
            <h2>So erreichen Sie uns</h2>
            <p>
              Telefon: 089-31868310<br />
              Fax: 089-3162218<br />
              E-Mail:
              <a href="mailto:info@waizmanntabelle.de">info@waizmanntabelle.de</a><br />
              Web:
              <a href="https://www.waizmanntabelle.de" target="_blank" rel="noopener">www.waizmanntabelle.de</a>
            </p>
          </article>

          <article class="imp-block">
            <span class="imp-block__tag">Tätigkeit</span>
            <h2>Art der Versicherungstätigkeit</h2>
            <p>
              Die WaizmannTabelle GmbH ist gemäß <strong>§ 93 HGB</strong> als
              Makler tätig — Versicherungsmakler mit Erlaubnis gemäß
              <strong>§ 34d Abs. 1 GewO</strong>.
            </p>
            <div class="imp-fact">
              <span class="imp-fact__l">IHK-Registernr.</span>
              <span class="imp-fact__v">D-AZHX-QKS5Z-54</span>
            </div>
            <p class="imp-block__small">
              Vermittlerregister: DIHK e.&nbsp;V., Breite Straße 29, 10178 Berlin —
              <a href="https://www.vermittlerregister.info" target="_blank" rel="noopener">www.vermittlerregister.info</a>
            </p>
          </article>

          <article class="imp-block">
            <span class="imp-block__tag">Absicherung</span>
            <h2>Berufshaftpflicht</h2>
            <p>
              Eine den Bestimmungen der EU-Vermittlerrichtlinie entsprechende
              Berufshaftpflicht- bzw. Vermögensschadenhaftpflichtversicherung
              liegt vor (über Nassau Versicherungen).
            </p>
            <h3>Beteiligungen</h3>
            <p class="imp-block__small">
              Die WaizmannTabelle GmbH besitzt keine direkten oder indirekten
              Beteiligungen oder Stimmrechte am Kapital eines
              Versicherungsunternehmens — und umgekehrt.
            </p>
          </article>

          <article class="imp-block">
            <span class="imp-block__tag">Aufsicht</span>
            <h2>Zuständige Aufsichtsbehörde</h2>
            <p>
              Industrie- und Handelskammer für München und Oberbayern<br />
              Max-Joseph-Str. 2, 80333 München<br />
              Telefon: 089-5116-0<br />
              <a href="https://www.ihk-muenchen.de" target="_blank" rel="noopener">www.ihk-muenchen.de</a>
            </p>
          </article>

          <article class="imp-block">
            <span class="imp-block__tag">Schlichtung</span>
            <h2>Schlichtungsstellen</h2>
            <p class="imp-block__small">
              <strong>BAFin</strong> — Graurheindorfer Straße 108, 53117 Bonn ·
              <a href="https://www.bafin.de" target="_blank" rel="noopener">www.bafin.de</a><br />
              <strong>Versicherungsombudsmann e.&nbsp;V.</strong> — Postfach 080622,
              10006 Berlin ·
              <a href="https://www.versicherungsombudsmann.de" target="_blank" rel="noopener">www.versicherungsombudsmann.de</a><br />
              <strong>PKV-Ombudsmann</strong> — Leipziger Str. 104, 10117 Berlin ·
              <a href="https://www.pkv-ombudsmann.de" target="_blank" rel="noopener">www.pkv-ombudsmann.de</a>
            </p>
          </article>
        </div>

        <article class="imp-text">
          <h2>Finanzierung der Waizmann-Webservices</h2>
          <p>
            Unsere Service-Leistungen sind für Kunden kostenlos. Wir erhalten von
            den meisten angeschlossenen Versicherungen eine Abschluss-Vergütung.
            Diese Vergütung hat keinerlei Einfluss auf das Ranking und den
            WaizmannWert.
          </p>

          <h2>EU-Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener">https://ec.europa.eu/consumers/odr</a>.
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>

          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen.
          </p>

          <h2>Datenschutz</h2>
          <p>
            Die Nutzung unserer Webseite ist in der Regel ohne Angabe
            personenbezogener Daten möglich. Soweit auf unseren Seiten
            personenbezogene Daten erhoben werden (etwa bei der Terminbuchung),
            erfolgt dies stets auf freiwilliger Basis und ausschließlich zur
            Terminabwicklung. Diese Daten werden ohne Ihre ausdrückliche
            Zustimmung nicht an Dritte weitergegeben.
          </p>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ImpressumIndex",
};
</script>

<style scoped>
.imp__hero {
  background: var(--wt-blue-soft);
  border-bottom: 1px solid var(--wt-blue-line);
  padding: 48px 0 36px;
}
.imp__h {
  font-size: clamp(34px, 5vw, 52px);
  font-weight: 900;
  letter-spacing: -0.8px;
  color: var(--wt-ink);
  margin: 0 0 10px;
}
.imp__lead {
  font-size: 16px;
  color: var(--wt-text);
  max-width: 640px;
  margin: 0;
}

.imp__body {
  padding: 40px 0 64px;
  background: #fff;
}
.imp__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}
@media (max-width: 980px) {
  .imp__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 640px) {
  .imp__grid { grid-template-columns: 1fr; }
}

.imp-block {
  background: #fff;
  border: 1.5px solid var(--wt-blue-line);
  border-radius: 12px;
  padding: 20px 18px;
}
.imp-block__tag {
  display: inline-block;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--wt-blue);
  background: var(--wt-blue-soft);
  padding: 3px 10px;
  border-radius: 999px;
  margin-bottom: 10px;
}
.imp-block h2 {
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.2px;
  color: var(--wt-ink);
  margin: 0 0 8px;
}
.imp-block h3 {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--wt-muted);
  margin: 14px 0 4px;
}
.imp-block p {
  font-size: 14px;
  line-height: 1.65;
  color: var(--wt-text);
  margin: 0;
}
.imp-block__small { font-size: 13px !important; }
.imp-block a { color: var(--wt-blue); font-weight: 600; }

.imp-fact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  background: var(--wt-blue-soft);
  border-radius: 8px;
  padding: 8px 12px;
  margin: 10px 0;
}
.imp-fact__l {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--wt-muted);
}
.imp-fact__v {
  font-weight: 900;
  color: var(--wt-blue-deep);
  font-size: 14px;
}

.imp-text {
  max-width: 760px;
}
.imp-text h2 {
  font-size: 19px;
  font-weight: 900;
  letter-spacing: -0.2px;
  color: var(--wt-ink);
  margin: 28px 0 8px;
}
.imp-text p {
  font-size: 14.5px;
  line-height: 1.7;
  color: var(--wt-text);
  margin: 0;
}
.imp-text a { color: var(--wt-blue); font-weight: 600; }
</style>
